import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { preBuiltItineraries } from '@/app/lib/pre-built-itineraries';
import { ArrowRight, Compass } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function DiscoverItinerariesPage() {
  return (
    <div className="container mx-auto">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 sm:mb-6 md:mb-8 gap-3 sm:gap-4">
        <div>
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight flex items-center gap-2 sm:gap-3">
            <Compass className="h-6 w-6 sm:h-8 sm:w-8 md:h-10 md:w-10 text-primary" />
            Discover Routes
          </h1>
          <p className="text-sm sm:text-base text-muted-foreground mt-1 sm:mt-2">
            Browse our collection of curated wild swimming adventures.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 md:gap-6">
        {preBuiltItineraries.map((itinerary) => (
          <Card key={itinerary.slug} className="flex flex-col">
            <CardHeader>
              <CardTitle>{itinerary.itinerary.title}</CardTitle>
              <CardDescription>
                A {itinerary.formValues.duration}-day trip for a {itinerary.formValues.skillLevel} swimmer.
              </CardDescription>
            </CardHeader>
            <CardContent className="flex-grow">
              <p className="text-sm text-muted-foreground line-clamp-3">
                {itinerary.itinerary.days.map(d => d.title).join(' & ')}
              </p>
            </CardContent>
            <div className="border-t p-3 sm:p-4 flex justify-end">
                <Button asChild variant="outline" size="sm" className="text-xs sm:text-sm">
                <Link to={`/itinerary/discover/${itinerary.slug}`}>
                    <span className="hidden sm:inline">View Route</span>
                    <span className="sm:hidden">View</span>
                    <ArrowRight className="ml-1 sm:ml-2 h-3.5 w-3.5 sm:h-4 sm:w-4" />
                </Link>
                </Button>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
